/**
 * Progress Repository Interface
 * Defines contract for user progress data access
 */

export class IProgressRepository {
  /**
   * Get user progress for a course
   * @param {string} userId
   * @param {string} courseId
   * @returns {Promise<UserProgress|null>}
   */
  async getUserProgress(userId, courseId) {
    throw new Error('Method not implemented');
  }

  /**
   * Create new user progress
   * @param {string} userId
   * @param {string} courseId
   * @returns {Promise<UserProgress>}
   */
  async createUserProgress(userId, courseId) {
    throw new Error('Method not implemented');
  }

  /**
   * Update user progress
   * @param {UserProgress} progress
   * @returns {Promise<UserProgress>}
   */
  async updateUserProgress(progress) {
    throw new Error('Method not implemented');
  }

  /**
   * Get section progress
   * @param {string} userId
   * @param {string} courseId
   * @param {string} sectionId
   * @returns {Promise<Object|null>}
   */
  async getSectionProgress(userId, courseId, sectionId) {
    throw new Error('Method not implemented');
  }

  /**
   * Update section progress
   * @param {string} userId
   * @param {string} courseId
   * @param {string} sectionId
   * @param {Object} progressData
   * @returns {Promise<Object>}
   */
  async updateSectionProgress(userId, courseId, sectionId, progressData) {
    throw new Error('Method not implemented');
  }

  /**
   * Get question progress
   * @param {string} userId
   * @param {string} courseId
   * @param {string} questionId
   * @returns {Promise<Object|null>}
   */
  async getQuestionProgress(userId, courseId, questionId) {
    throw new Error('Method not implemented');
  }

  /**
   * Update question progress
   * @param {string} userId
   * @param {string} courseId
   * @param {string} questionId
   * @param {Object} progressData
   * @returns {Promise<Object>}
   */
  async updateQuestionProgress(userId, courseId, questionId, progressData) {
    throw new Error('Method not implemented');
  }

  /**
   * Save answer history
   * @param {string} userId
   * @param {string} courseId
   * @param {string} questionId
   * @param {Object} answerData
   * @returns {Promise<Object>}
   */
  async saveAnswerHistory(userId, courseId, questionId, answerData) {
    throw new Error('Method not implemented');
  }

  /**
   * Get answer history for a question
   * @param {string} userId
   * @param {string} courseId
   * @param {string} questionId
   * @returns {Promise<Array>}
   */
  async getAnswerHistory(userId, courseId, questionId) {
    throw new Error('Method not implemented');
  }
}
